import { useQuery } from 'react-query';
import { getAllStudentsForSelectionAsync } from '../../index'; 

export const STUDENT_KEYS = {
  ALL: 'students',
  SELECTION: 'selection',
};

export const useGetAllStudentsForSelectionQuery = () => {
  return useQuery(
    [STUDENT_KEYS.ALL, STUDENT_KEYS.SELECTION],
    async () => {
      return getAllStudentsForSelectionAsync();
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60,
    }
  );
};